import React, { useState, useEffect } from 'react';

import Select from 'react-select'

import FileBase from "react-file-base64"
import { Tag } from './index'
import { useDispatch } from 'react-redux';
import { createPosts, updatePost } from '../actions/posts';
import { getTags } from '../actions/tags';
import { getPartners } from '../actions/partners';
import { getPlants } from '../actions/plants';
import { useSelector } from 'react-redux';

type PropsForm = {
    currentId?: number;
    setCurrentId?: any;
};

const Form: React.FC<PropsForm> = ({ currentId, setCurrentId}) => {

    const [postData, setPostData] = useState({ title: '', goals: '', working_method:'', creator: '', tags: [{}], plants: [{}], partners: [{}], images: ''});
    
    const [selectedPlantValue, setSelectedPlantValue] = useState([]);
    const [selectedPartnerValue, setSelectedPartnerValue] = useState([]);

    //Get data from Redux
    const post = useSelector((state: any) => currentId ? state.posts.find((p) => p._id === currentId) : null)
    const tags = useSelector((state: any) => state.tags)
    const plants = useSelector((state: any) => state.plants)
    const partners = useSelector((state: any) => state.partners)
    // const tag = useSelector((state: any) => state.tags.find((p) => p._id === currentTagId) : null)
    const dispatch = useDispatch();

    //If post is selected for modification => data inside useState (postData) for display them
    const selectedPlant = []
    const selectedPartner = []

    useEffect(() => {
        if (post) {
            setPostData(post)
            post.plants.forEach(plantId => {
                selectedPlant.push(plants.find((plant) => plant._id === plantId))
            });
            setSelectedPlantValue(selectedPlant);
            post.partners.forEach(partnerId => {
                selectedPartner.push(partners.find((partner) => partner._id === partnerId))
            });
            setSelectedPartnerValue(selectedPartner);
        }
    }, [post, dispatch])

     const options: any = tags.map(tag => ({
        label: tag.title,
        value: tag
     }));
    
    const optionsPlant = plants.map(plant => ({
        label: plant.title,
        value: plant
    }));

    const optionsPartner = partners.map(partner => ({
        label: partner.title,
        value: partner
    }));
    
    
    // useEffect(() => {
    //     if (plant) setPlantData(plant)
    //     if (plant) {
    //         plant.benefits.forEach(benefitId => {
    //             selectedBenefit.push(benefits.find((benefit) => benefit._id === benefitId))
    //         });
    //         setSelectedPlantValue(selectedBenefit);
    //     }
    // }, [plant])


    
    //PLANT


    const handleChangePlants = (e) => {
        setSelectedPlantValue(Array.isArray(e) ? e.map(x => x.value) : []);
    }

    const handleChangePartners = (e) => {
        setSelectedPartnerValue(Array.isArray(e) ? e.map(x => x.value) : []);
    }

    useEffect(() => {
        setPostData({ ...postData, plants: selectedPlantValue })
    }, [selectedPlantValue])

    useEffect(() => {
        setPostData({ ...postData, partners: selectedPartnerValue })
    }, [selectedPartnerValue])

    
    
    // options.filter((option) => option.value._id == postData.tags)
    
    //Get display function from reduc 
    useEffect(() => {
        dispatch(getTags())
        dispatch(getPlants())
        dispatch(getPartners())
    }, [dispatch])

    const handleSubmit = (event: any) => {
        event.preventDefault();
        if (currentId) {
            dispatch(updatePost(currentId, postData))
        } else {
            dispatch(createPosts(postData));
        }
        clear();
    }

    const clear = () => {
        setCurrentId(null)
        setPostData({ title: '', goals: '', creator: '', working_method:'', tags: [{}], plants: [{}], partners: [{}], images: ''});
    }
    

    return (
        <form className="_shadow-xl _bg-white _rounded-card _p-md _w-auto" onSubmit={handleSubmit}>
            <h1 className="_text-center">{currentId ? 'Modifier' : 'Créer'} un îlot </h1>
            <div className="_flex _flex-col">
                <div className="_flex _flex-col">
                    <input
                        className="_p-xs _rounded-md _my-sm _bg-gray"
                        type="text"
                        name="creator"
                        value={postData.creator}
                        placeholder="Creator"
                        onChange={(e) => setPostData({ ...postData, creator: e.target.value })}
                    />
                    <input
                        className="_p-xs _rounded-md _bg-gray _mb-sm"
                        type="text"
                        name="title"
                        value={postData.title}
                        placeholder="Titre"
                        onChange={(e) => setPostData({ ...postData, title: e.target.value })}
                    />
                    <textarea
                        className="_p-xs _rounded-md _bg-gray _mb-sm"
                        style={{ height: '200px' }}
                        name="goals"
                        value={postData.goals}
                        placeholder="Objectifs"
                        onChange={(e) => setPostData({ ...postData, goals: e.target.value })}
                    />
                </div>
                <div className="_flex _flex-col">
                    <textarea
                        className="_p-xs _rounded-md _my-sm _bg-gray"
                        style={{ height: '200px' }}
                        name="working_method"
                        value={postData.working_method}
                        placeholder="Methode de travail"
                        onChange={(e) => setPostData({ ...postData, working_method: e.target.value })}
                    />
                    <section>
                        <div className="_flex _flex-wrap _mb-md _p-sm _bg-gray _rounded-md">
                            <div className="_mb-md _w-full">
                                <h2 className="_mb-sm"> Choisissez un tag : </h2>
                                <Select required classNamePrefix="select" className="basic-single" name="tags" options={options}  getOptionValue={(option) => option.value} onChange={(item: any) => setPostData({ ...postData, tags: item.value })} />
                                {/* <Select required classNamePrefix="select" className="basic-single" name="tags" options={options} getOptionValue={(option) => option.value} onChange={(item: any) => console.log(item.value)} /> */}
                            </div>
                        </div>
                        <div className="_flex _flex-wrap _mb-md _p-sm _bg-gray _rounded-md">
                            <div className="_mb-md _w-full">
                                <h2 className="_mb-sm"> Choisissez des plantes : </h2>
                                <Select required classNamePrefix="select" className="basic-single" name="plants" isMulti options={optionsPlant} onChange={handleChangePlants} />
                                {/* <Select required classNamePrefix="select" className="basic-single" name="tags" options={options} getOptionValue={(option) => option.value} onChange={(item: any) => console.log(item.value)} /> */}
                            </div>
                        </div>
                        <div className="_flex _flex-wrap _mb-md _p-sm _bg-gray _rounded-md">
                            <div className="_mb-md _w-full">
                                <h2 className="_mb-sm"> Choisissez un ou des partenaires : </h2>
                                <Select required classNamePrefix="select" className="basic-single" name="plants" isMulti options={optionsPartner} onChange={handleChangePartners} />
                                {/* <Select required classNamePrefix="select" className="basic-single" name="tags" options={options} getOptionValue={(option) => option.value} onChange={(item: any) => console.log(item.value)} /> */}
                            </div>
                        </div>
                    </section>
                    <FileBase
                        type="file"
                        name="images"
                        multiple={false}
                        className="_p-xs _rounded-md _mb-sm _bg-gray"
                        onDone={({base64}) => setPostData({ ...postData, images: base64})}
                    />
                </div>
            </div>
            <div className="_flex _justify-end _mt-sm">
                <button type="reset" onClick={clear}>Annuler </button>
                <button type="submit" className="_ml-sm _bg-green _rounded-md hover:_bg-darkengreen _text-white _font-bold _py-xs _px-sm _rounded-lg">
                    {currentId ? 'Modifier' : 'Créer'}
                </button>
            </div>
        </form>
    );
    
};

export default Form;



